import { render, staticRenderFns } from "./TableResults.vue?vue&type=template&id=58cfaeaa&scoped=true&"
import script from "./TableResults.vue?vue&type=script&lang=ts&"
export * from "./TableResults.vue?vue&type=script&lang=ts&"
import style0 from "./TableResults.vue?vue&type=style&index=0&id=58cfaeaa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cfaeaa",
  null
  
)

export default component.exports